import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
	privacyPolicyLink?: string;
	rulesLink?: string;
	centerText?: boolean;
}

const OrderPaymentInfo = ({ privacyPolicyLink, rulesLink, centerText }: Props) => {
	const { t } = useTranslation();

	return (
		<span className="order-payment-info" style={{ textAlign: centerText ? "center" : "left" }}>
			{`${t("modules.e_order.field.by_making_a_payment_you_accept.title")} `}
			<a href={rulesLink ?? "https://www.gopos.pl/tos"}>{t("lib:go_security.register.words.tos")}</a>{" "}
			{`${t("common.word.or")} `}
			<a href={privacyPolicyLink ?? "https://www.gopos.pl/privacy-policy"}>
				{t("modules.e_order.field.privacy_policy.title")}
			</a>
		</span>
	);
};

export default OrderPaymentInfo;
